import React from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { SearchFormValues, searchSchema } from '../../schema';
import BasicInfoTab from './BasicInfoTab';
import FilterTab from './FilterTab';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (filters: BanHangPayload) => void;
}

const SearchDialog = ({ open, onClose, onSearch }: SearchDialogProps) => {
  const handleSubmit = (data: SearchFormValues) => {
    onSearch(data);
    onClose();
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Lọc Hóa đơn dịch vụ trả lại, giảm giá'
      maxWidth='md'
      disableBackdropClose
      disableEscapeKeyDown
      titleIcon={<AritoIcon icon={12} />}
      showFullscreenToggle={false}
      paperClassName='w-[800px] max-h-[85vh]'
      classNameContent='overflow-hidden'
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-250px)] overflow-y-auto'>
            <BasicInfoTab formMode='add' />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'detail',
                  label: 'Chi tiết',
                  component: <FilterTab formMode='add' />
                }
              ]}
              className='border-b border-b-gray-200'
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='add' onClose={onClose} submitTitle='Đồng ý' />}
      />
    </DialogV2>
  );
};

export default SearchDialog;
